<div class="page-container">
  <div class="mb-5 font-white text-center fs-40">Trainer Commission Contracts</div>

  <div *ngFor="let center of centers" class="contract-card bg-card-secondary p-3 mb-3 border-radius-10">
    <div class="font-blue fs-25">{{ center.name }}</div>
    <hr />
    <div class="fs-20">Commission Structure Details</div>

    <div *ngIf="center.coaches.length === 1">
      <div class="fs-14 font-gray">As the sole coach, the entire commission generated by the center is allocated to them.</div>
      <div class="p-3 mt-3 border-radius-10 bg-card">
        <div class="fs-18">{{ center.coaches[0].name }} :</div>
        <div class="fs-14">{{ center.coaches[0].commissionText }}</div>
      </div>
    </div>

    <div *ngIf="center.coaches.length > 1 && center.commissionModel === 'center-wide'">
      <div class="fs-14 font-gray">Commission is distributed equally among all coaches operating in this center.</div>
      <div *ngFor="let coach of center.coaches" class="p-3 mt-3 border-radius-10 bg-card">
        <div class="fs-18">{{ coach.name }} :</div>
        <div class="fs-14">{{ coach.commissionText }}</div>
      </div>
    </div>

    <div *ngIf="center.commissionModel === 'batch-wise'">
      <div class="fs-14 font-gray">Commission is calculated independently for each batch based on its performance.</div>
      <div *ngFor="let coach of center.coaches" class="p-3 mt-3 border-radius-10 bg-card">
        <div class="fs-18">{{ coach.name }} ({{ coach.batch }} Batch) :</div>
        <div class="fs-14">{{ coach.commissionText }}</div>
      </div>
    </div>
  </div>
</div>

<div class="container">
  <div class="card">
      <div class="card-header">
        <div>
          <h1>Trainer Contract Management</h1>
          <p>Commission Distribution System</p>
        </div>
      </div>

      <!-- Input fields for contract details -->
      <div class="form-grid">
        <div class="form-group">
          <div>
            <label class="form-label" for="centerName">Center Name</label>
            <input type="text" [value]="centerName()" (input)="centerName.set($any($event.target).value)" class="form-input" />
          </div>

          <div>
            <label class="form-label" for="totalRevenue">Total Revenue (₹)</label>
            <input type="number" [value]="totalRevenue()" (input)="totalRevenue.set(+$any($event.target).value)" class="form-input" />
          </div>
        </div>

        <div class="form-group">
          <div>
            <label class="form-label" for="commissionRate">Commission Rate (%)</label>
            <input type="number" [value]="commissionRate()" (input)="commissionRate.set(+$any($event.target).value)" min="0" max="100" class="form-input" />
          </div>

          <div>
            <label class="form-label" for="distributionType">Distribution Type</label>
            <select [value]="distributionType()" (change)="distributionType.set($any($event.target).value)" class="form-select">
              <option value="equal">Equal Distribution</option>
              <option value="batch">Batch-wise Distribution</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Summary cards -->
      <div class="summary-section">
        <div class="summary-grid">
          <div class="summary-card">
            <div class="summary-card-icon revenue">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="1" x2="12" y2="23"></line>
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
              </svg>
            </div>
            <div class="summary-card-text">
              <p>Total Revenue</p>
              <p class="total-revenue">₹{{ totalRevenue().toLocaleString("en-IN") }}</p>
            </div>
          </div>

          <div class="summary-card">
            <div class="summary-card-icon commission">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                <polyline points="16 7 22 7 22 13"></polyline>
              </svg>
            </div>
            <div class="summary-card-text">
              <p>Total Commission</p>
              <p class="total-commission">₹{{ totalCommissionAmount().toLocaleString("en-IN", { maximumFractionDigits: 2 }) }}</p>
            </div>
          </div>

          <div class="summary-card">
            <div class="summary-card-icon trainers">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <div class="summary-card-text">
              <p>Active Trainers</p>
              <p class="active-trainers">{{ activeTrainers().length }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Trainers management section -->
      <div class="trainers-section">
        <div class="trainers-header">
          <h2>Trainers</h2>
          <button (click)="addTrainer()" class="btn btn-add">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            Add Trainer
          </button>
        </div>

        <div class="trainers-list">
          @for (trainer of trainers(); track trainer.id) {
          <div class="trainer-item">
            <div class="trainer-item-grid">
              <input type="text" placeholder="Trainer Name" [value]="trainer.name" (input)="updateTrainer(trainer.id, 'name', $any($event.target).value)" class="form-input trainer-name-input" />

              @if (distributionType() === 'batch') {
              <select [value]="trainer.batch" (change)="updateTrainer(trainer.id, 'batch', $any($event.target).value)" class="form-select">
                <option value="all">All Day</option>
                <option value="morning">Morning Batch</option>
                <option value="evening">Evening Batch</option>
              </select>
              } @else {
              <div class="hidden-placeholder"></div>
              }

              <label class="checkbox-label">
                <input type="checkbox" [checked]="trainer.active" (change)="updateTrainer(trainer.id, 'active', $any($event.target).checked)" />
                <span>Active</span>
              </label>

              <button (click)="removeTrainer(trainer.id)" class="btn btn-remove">Remove</button>
            </div>
          </div>
          }
        </div>
      </div>

      <!-- Commission results section -->
      <div class="results-section">
        <h2 class="results-header">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <polyline points="16 11 18 13 22 9"></polyline>
          </svg>
          Commission Distribution
        </h2>

        <div class="results-list">
          @for (result of commissionResults(); track result.id) {
          <div class="result-item">
            <div class="result-item-content">
              <div>
                <p class="result-item-name">{{ result.name || "Unnamed Trainer" }}</p>
                <div class="result-item-details">
                  @if (distributionType() === 'batch') {
                  <span class="batch-tag">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    {{ result.batch === "morning" ? "Morning" : result.batch === "evening" ? "Evening" : "All Day" }}
                  </span>
                  }
                  <span class="percentage-text">{{ result.percentage.toFixed(1) }}% of total</span>
                </div>
              </div>
              <div class="result-item-amount">
                <p>₹{{ result.commission.toLocaleString("en-IN", { maximumFractionDigits: 2 }) }}</p>
                <p>Commission</p>
              </div>
            </div>
          </div>
          }
        </div>

        @if (commissionResults().length === 0) {
        <div class="no-results">
          <p>No active trainers to distribute commission</p>
        </div>
        }
      </div>
    </div>
  </div>
